/**
 * Firm-tenant client experience rules (#1517, #1518 — go-live blockers).
 *
 * Pure decision module (React-free) for what a firm-managed client — a client
 * whose case has an active advisor_connection — may see:
 *
 * - No B2C upsell surfaces: the firm pays; their client must never see a
 *   SettleWise paywall, premium nudge, or founding-member badge (ROF F-C2).
 * - No psych/negotiation suite: a client authoring "spouse is narcissistic /
 *   leverage points" inside a litigation platform creates discoverable
 *   material their attorney never sanctioned (ROF F-C4). Blocked pending
 *   privilege review, enforced at the ROUTE level (direct URLs included),
 *   not just hidden from navigation.
 */

/** Client routes blocked for firm-managed clients (sub-routes included). */
export const FIRM_BLOCKED_CLIENT_ROUTES = [
  '/know-your-spouse',
  '/asset-emotions',
  '/sibyl',
  '/settlement-wizard',
] as const;

const LOCALE_PREFIX = /^\/(en|es|zh)(?=\/)/;

/**
 * Whether `pathname` is off-limits for this client. Locale prefixes are
 * stripped; matching is segment-exact so `/sibyl-report` never matches
 * `/sibyl` while `/sibyl/anything` does.
 */
export function isFirmBlockedRoute(pathname: string, isFirmManaged: boolean): boolean {
  if (!isFirmManaged) return false;
  const path = pathname.replace(LOCALE_PREFIX, '');
  return FIRM_BLOCKED_CLIENT_ROUTES.some(
    (blocked) => path === blocked || path.startsWith(`${blocked}/`),
  );
}

/**
 * Whether B2C upsell surfaces (premium nudges, paywall checkout CTAs,
 * founding-member badge, usage soft-nudges) may render for this client.
 */
export function showUpsellSurfaces(isFirmManaged: boolean): boolean {
  return !isFirmManaged;
}
